
import { CartService } from '../../shared/services/cart.service';
import remove from 'lodash-es/remove';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CacheService } from '../../shared/services/cache.service';
import { Router } from '@angular/router';
import { CacheKey } from '../../shared/constants/cachekey.constants';

import { Cart } from '../../shared/models/cart.model';
import { CartTypes } from '../../shared/enums/cart-types.enum';
import { Item } from '../../shared/models/item.model';
import { CookieBannerType } from '../../shared/enums/cookie-banner-type';
import { ImageTypeFilterPipe } from '../pipes/image-type-filter.pipe';
import { PurchaseFlow } from '../../shared/enums/purchase-flow.enum';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { Options } from '../../products/interfaces/options.interface';
import { Product } from '../../products/interfaces/product.interface';
import { Member } from '../../shared/interfaces/member.interface';
import { ImageType } from '../../products/enums/image-type.enum';
import { CommonService } from '../../shared/services/common.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { AppMessageService } from '../../app-message.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductType } from '../../products/enums/product-types.enum';
import { Quickview } from '../../products/interfaces/product-quickview.interface';
import { environment } from '../../../environments/environment';
import { CookieBannerMessageType } from '../../shared/enums/cookie-message-types.enum';
import { ProductService } from '../services/product.service';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { ActiveSessionService } from '../../shared/services/active-session.service';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'app-quickview',
    templateUrl:
        '../templates/template1/views/quickview.component.html',
    styleUrls: [
        '../templates/template1/themes/less/quickview.component.less',
        '../templates/template1/themes/less/bestseller-products.component.less'
    ],
    providers: [ImageTypeFilterPipe]

})
export class QuickviewComponent implements OnInit, OnDestroy {
    isPersonalPurchaseFlow = false;
    personalPurchaseFlow: string = PurchaseFlow.PERSONAL;
    purchaseFlows: any[] = [];
    storeId: number;
    store: StoreConfig;
    selectedFilter: any = {};
    options: Options[];
    languageCode: any;
    quickViewItem: any;
    public isModalShown = false;
    defaultProductsUnSubscription: any;
    products: Product[] = [];
    showOptions = false;
    quantity = 1;
    isoCountryCode: string;
    userLoggedIn: Member;
    productSlug: string;
    product: any;
    productDetails: Product;
    errorMessages: string;
    imageTypes = ImageType;
    memberTitle = MemberLevel;
    memberTitleId: number = MemberLevel.RETAIL;
    disableDecrement: boolean;
    isAutoshipEnabled: boolean;

    constructor(
        private _cacheService: CacheService,
        private _productService: ProductService,
        private _commonService: CommonService,
        private _configurationService: ConfigurationService,
        public bsModalRef: BsModalRef,
        private _appMessageService: AppMessageService,
        private _cartService: CartService,
        private _translatePipe: TranslateService,
        private _activeSessionService: ActiveSessionService
    ) { }

    ngOnInit() {
        this.getStoreData();
        this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        if (this.productDetails) {
            this.quickViewItem = this.productDetails;
            this.getVariableProductOptions();
        }

        this.userLoggedIn = this._cacheService.get(CacheKey.UserInfo);
        this.memberTitleId = this._activeSessionService.getMemberTitleId();
    }

    /**
  * To show quick view popup
  * @param  {any} prodId
  * @returns void
  */
    getVariableProductOptions(): void {
        if (this.quickViewItem && this.quickViewItem.options && this.quickViewItem.options.length > 0 &&
            ProductType.Variable === this.quickViewItem.productTypeMasterId) {
            this.options = this.quickViewItem.options.filter(
                x => x.name != null && x.productOptionValueMasterId != null
            );
            this.options[0].isPrimary = true;
            this.quickViewItem.options[0].selected = this.quickViewItem.options[0].values[0].name;
            this.optionsChange(this.quickViewItem, this.options[0].values[0].name, this.options[0], true, null);
        }
        // this.quantity = this.getQuantity(product.id);
        if (ProductType.Variable === this.quickViewItem.productTypeMasterId) {
            this.showOptions = true;
        } else {
            this.showOptions = false;
        }
    }



    /**
    * @param  {string} optType
    * @param  {string} optValue
    */
    optionsChange(quickViewItem: Quickview, optValue: string, option: Options, defaultValue: boolean, $evt?: any): void {
        this.selectedFilter = { selectedOption: '', selectedValue: '' };
        this.selectedFilter.selectedOption = option.productOptionValueMasterId;
        this.selectedFilter.selectedValue = optValue;
        let selectedProd: any = [];
        const oneOption = this.options.filter(x => x.productOptionValueMasterId !== option.productOptionValueMasterId);
        if (oneOption && oneOption.length > 0) {
            this.options.filter(x => x.productOptionValueMasterId !== option.productOptionValueMasterId).forEach(x => {
                x.selected = '';
                x.values.forEach(val => {
                    if (selectedProd && selectedProd.length === 0) {
                        selectedProd = quickViewItem.optionCombinationValues.filter(z => z['' + option.name]
                            === this.selectedFilter.selectedValue && z[x.name] === val.name);
                        selectedProd = selectedProd && selectedProd.length === 0 && (!val.hide) ? selectedProd : selectedProd;
                    }
                    if (defaultValue) {
                        val.hide = true;
                    } else {
                        val.hide = quickViewItem.optionCombinationValues.filter(z => z['' + option.name]
                            === this.selectedFilter.selectedValue && z[x.name] === val.name).length <= 0;
                        x.selected = x.selected.length === 0 && (!val.hide) ? val.name : x.selected;
                    }
                });
                // reset all drop down's to select except first option
                if (option.name !== x.name) {
                    const el: any = document.getElementById('option_' + x.name);
                    if (el) {
                        // reset option to select
                        if (x.values.map(y => y.name).indexOf(el.value) === -1) {
                            el.value = '';
                        } else {
                            el.value = x.values.find(value => !value.hide).name;
                        }
                    }
                }
            });
        } else {
            selectedProd = quickViewItem.optionCombinationValues.filter(z => z['' + option.name] === this.selectedFilter.selectedValue);
        }

        if (selectedProd && selectedProd[0]) {
            this.getProductByOptions(selectedProd[0].productId);
        }
    }

    /**
    * Get Products by options selections
    * @param  {number} productId
    */
    getProductByOptions(productId: number): void {
        if (this.storeId) {
            this._productService
                .getProductById(productId, this.storeId, this.languageCode)
                .subscribe(response => {
                    if (response) {
                        const prodDetail: Product = response[0];
                        prodDetail.productQuantity = 1;
                        prodDetail.optionCombinationValues = this.quickViewItem.optionCombinationValues;
                        prodDetail.options = this.quickViewItem.options;
                        prodDetail.parentProductSlug = this.quickViewItem.parentProductSlug || this.quickViewItem.slug;
                        prodDetail.selectedOption = this.selectedFilter.selectedValue;
                        this.quickViewItem = prodDetail;
                        this.options = prodDetail.options;
                        this.loadWishListProducts();
                        // this.filterParentImage();
                    }
                });
        }
    }

    /**
   * load wishlist
   */
    loadWishListProducts(): void {
        const wishListCart: Cart = this._cacheService.get(CacheKey.WishListSession);
        if (wishListCart && wishListCart.items.length > 0) {
            wishListCart.items.forEach(y => {
                if (y.productId === this.quickViewItem.id) {
                    this.quickViewItem.wishListItem = true;
                }
            });
        }
    }


    /**
       * To hide quick view popup
       * @returns void
       */
    hideModal(): void {
        // this.autoShownModal.hide();
    }

    /**
       * @returns void
       */
    onHidden(): void {
        this.isModalShown = false;
        //  this.autoShownModal.hide();
    }

    /**
     * get Store Data
     */
    getStoreData(): void {
        const storeConfig: StoreConfig = this._configurationService.getStoreData();
        if (storeConfig) {
            this.store = storeConfig;
            this.storeId = this.store.id;
            this.purchaseFlows = storeConfig.purchaseFlows;
            this.hasPurchaseFlow();
        }
    }

    /**
     * @description Purchase flow check
     * @date 2018-08-13
     * @memberof QuickviewComponent
     */
    hasPurchaseFlow(): void {
        if (this.purchaseFlows && this.purchaseFlows.length > 0
            && (this.store.purchaseFlows !== null && this.store.purchaseFlows.length > 0)) {
            this.purchaseFlows.forEach(flow => {
                this.store.purchaseFlows.forEach((storeFlow: any) => {
                    if (flow.id === storeFlow.id && flow.name === this.personalPurchaseFlow) {
                        this.isPersonalPurchaseFlow = true;
                    }
                });
            });
        }
    }

    /**
    * Increment the product Quantity
    * @returns void
    */
    incrementQuantity(prod): void {
        prod.productQuantity = ++prod.productQuantity;
        this.disableDecrement = false;
        if (!prod.stockAvailable || (prod.manageStock && !prod.backOrderAllowed && (prod.stockQuantity <= 0 || prod.productQuantity > prod.stockQuantity))) {
            //if (prod.productQuantity > prod.stockQuantity && !prod.backOrderAllowed) {
            prod.errorMessage = true;
            setTimeout(() => {
                prod.errorMessage = false;
            }, 2000);
            prod.productQuantity = parseInt(prod.productQuantity, 10) - 1;
            this.outofStockNotification(prod);
        }
    }

    /**
     * Out of Stock Notification
     * @param product
     */
    outofStockNotification(product: Product) {
        // const cartStockErrorForItem: any = this._translatePipe.get('stockError.No Stock Available for Item Number');
        // this._notificationService.createNotification('', 'Available Stock: <span class="helvetica-bold">' +
        //   product.stockQuantity + '</span>', NotificationType.ERROR);
    }

    /**
    * Decrement the product Quantity
    * @returns void
    */
    decrementQuantity(prod): void {
        if (prod.productQuantity > 1) {
            prod.productQuantity = parseInt(prod.productQuantity, 10) - 1;
            // this.quantity = +this.quantity - 1;
        }
        if (prod.productQuantity === 1) {
            this.disableDecrement = true;
        }
    }

    /**
    * to update product quantity
    */
    updateQuantity(prod: Product | any) {
        const qty = parseInt(prod.productQuantity, 10);
        if (!prod.stockAvailable || (prod.manageStock && !prod.backOrderAllowed && (prod.stockQuantity <= 0 || qty > prod.stockQuantity))) {
            //if (qty > prod.stockQuantity && !prod.backOrderAllowed) {
            prod.errorMessage = true;
            setTimeout(() => {
                prod.errorMessage = false;
            }, 2000);
            prod.productQuantity = prod.stockQuantity;
            this.outofStockNotification(prod);
        } else {
            prod.productQuantity = qty || null;
        }
        if (this.quantity > 1) {
            this.disableDecrement = false;
        } else {
            this.disableDecrement = true;
        }
    }

    /**
    * show cart / Product detail based on variant.
    */
    addToCart(product: any, cartType: number): void {
        this.manageShoppingCart(product, cartType);
    }

    /**
 * goto detail page in shop
 * @param  {string} slug
 * @returns void
 */
    gotoProductDetail(slug: string): void {
        let url = environment.shopURL + '/'
            + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/products/' + slug;
        url = this._commonService.appendFBOID(url);
        window.location.href = url;
    }


    /**
     * @param  {Product} product
     * @param  {CartTypes} cartType
     */
    private manageShoppingCart(product: Product, cartType: CartTypes) {
        const itemAddedNotification: any = this._translatePipe.get('Item added to cart');
        let cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
        const item: Item = this._cartService.convertProductToItemMappper(product, cartSessionInfo);
        if (cartSessionInfo) {
            const cartItem = cartSessionInfo.items.filter(x => x.productId === item.productId)[0];
            if (cartItem) {
                item.quantity = cartItem.quantity + item.quantity;
                if (item.quantity > product.stockQuantity && product.manageStock && !product.backOrderAllowed) {
                    item.quantity = cartItem.quantity;
                    product.errorMessage = true;
                    setTimeout(() => {
                        product.errorMessage = false;
                    }, 2000);
                    const cartStockErrorForItem: any = this._translatePipe.get('stockError.No Stock Available for Item Number');
                    // this._commonService.createNotification('', cartStockErrorForItem.value +' '+ product.itemNumber, 'error');
                    return;
                }
            }
            const mergeCartSession: Cart = JSON.parse(JSON.stringify(cartSessionInfo));
            // cartSessionInfo.items = _.remove(cartSessionInfo.items, function (n: any) {
            //   return n.productId !== product.id;
            // });
            this._cartService.updateCart([item], cartType, cartItem, cartSessionInfo).subscribe((response: any) => {
                if (response) {
                    this.bsModalRef.hide();
                    cartSessionInfo = this._cartService.mergeCartSession(item, response, mergeCartSession);
                    this._cacheService.set(CacheKey.CartSessionInfo, cartSessionInfo);
                    this._appMessageService.setMiniCart(response.sessionGuid);
                    const shoppingCart = new Cart(cartSessionInfo, this.store);
                    this._appMessageService.setCartItemsChanges(shoppingCart.itemsCount);
                    this._appMessageService.showMiniCartView(product.id);
                    this._commonService.focusTargetElement('minicart-shop-msg');
                    // this._commonService.scrollTo('static-tempate', 500);
                }
            });
        } else {
            this._cartService.saveCart([item], cartType).subscribe((response: any) => {
                if (response) {
                    this.bsModalRef.hide();
                    cartSessionInfo = this._cartService.mergeCartSession(item, response, cartSessionInfo);
                    this._cacheService.set(CacheKey.CartSessionInfo, cartSessionInfo);
                    this._appMessageService.setMiniCart(response.sessionGuid);
                    const shoppingCart = new Cart(cartSessionInfo, this.store);
                    this._appMessageService.setCartItemsChanges(shoppingCart.itemsCount);
                    this._appMessageService.showMiniCartView(product.id);
                    this._commonService.focusTargetElement('minicart-shop-msg');
                    // this._commonService.scrollTo('static-tempate', 500);
                }
            });
        }
    }

    /**
    * verifying whether the product is shippable to the selected shipping address or not
    * @returns Address
    */
    //   getShippingRestrictedProducts(itemNumber: string): any {
    //     const userDefaultAddressDetails = this._cacheService.get(CacheKey.UserDefaultAddress);
    //     if (userDefaultAddressDetails) {
    //       this._commonService.getShippingRestrictedProducts(itemNumber)
    //         .subscribe((response: any) => {
    //           if (response && response.productModels && response.productModels.length > 0) {
    //             this._notificationService.createNotification('', response.productModels[0].errorDescription, NotificationType.ERROR);
    //           }
    //         });
    //     }
    //   }

    /**
  * To add an item
  * @param  {Product} product
  */
    addToWishList(product: Product): void {
        // if (!this.userLoggedIn) {
        //   return;
        // }
        // TODO amruth - need to move text to s3 and translate
        if (!this.userLoggedIn) {
            const cookieBannerData = {
                title: null,
                timeout: false,
                time: 2000,
                description: 'Please Login to add products to your favorites.',
                notificationMessageType: CookieBannerMessageType.Favourites,
                notificationType: CookieBannerType.CartItemNotification
            };
            this._appMessageService.setCookieBannerData(cookieBannerData);
            return;
        }
        const itemAddedNotification: any = this._translatePipe.get('quickview.Item added to Wish List');
        const itemDeletedNotification: any = this._translatePipe.get('quickview.Item removed from Wish List');
        product.wishListItem = !product.wishListItem ? true : false;
        const item: Item = this._cartService.convertProductToItemMappper(product);
        let wishListCart: Cart = this._cacheService.get(CacheKey.WishListSession);
        if (product.wishListItem && wishListCart && wishListCart.items && wishListCart.items.length >= 0 && wishListCart.sessionGuid) {
            const cartItem: Item = wishListCart.items.find(x => x.productId === product.id);
            wishListCart.items = remove(wishListCart.items, function (n: any) {
                return n.productId !== product.id;
            });
            this._cartService
                .updateCart([item], CartTypes.WishlistCart, cartItem, wishListCart)
                .subscribe((response: Cart) => {
                    if (response) {
                        wishListCart = this._cartService.mergeCartSession(item, response, wishListCart);
                        this._cacheService.set(CacheKey.WishListSession, wishListCart);
                        this._appMessageService.setWishListItems();
                    }
                });
        } else if (product.wishListItem) {
            this._cartService
                .saveCart([item], CartTypes.WishlistCart)
                .subscribe((response: Cart) => {
                    if (response) {
                        wishListCart = this._cartService.mergeCartSession(item, response, wishListCart);
                        this._cacheService.set(CacheKey.WishListSession, wishListCart);
                        this._appMessageService.setWishListItems();
                    }
                });
        } else if (!product.wishListItem) {
            const cartItem: Item = wishListCart.items.find(x => x.productId === product.id);
            wishListCart.items = remove(wishListCart.items, function (n: any) {
                return n.productId !== product.id;
            });
            this._cartService
                .removeCartItem(wishListCart.sessionGuid, cartItem.id)
                .subscribe((response: any) => {
                    wishListCart = new Cart(wishListCart, this.store);
                    this._cacheService.set(CacheKey.WishListSession, wishListCart);
                    this._appMessageService.setWishListItems();
                }, (error: any) => {
                  });
        }
    }

    /**
     * @description
     * @date 2018-10-17
     * @param {boolean} isLogin
     * @param {Product} product
     * @memberof QuickviewComponent
     */
    gotoLogin(isLogin: boolean, product: Product): void {
        this._cacheService.set(CacheKey.RedirectToFavourites, true);
        product.productQuantity = 1;
        this._cacheService.setCookieValue(CacheKey.WishListProduct, product.id);
        this._appMessageService.setNotifyLoginStatus(isLogin);
    }

    /**
     * @description navigateToShop will redirect users to shop site
     * to respective product details page based on slug
     * @date 2018-08-14
     * @param {Product} product
     * @memberof QuickviewComponent
     */
    navigateToShop(product: Product): void {
        const redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase()
            + '/products/' + product.slug;
        window.location.href = redirectUrl;
    }


    ngOnDestroy(): void {
        // this.defaultProductsUnSubscription.unsubscribe();
    }
}
